// Secret 13 - A Collection of Secrets
// Brand Identity Product Data

// Size options with pricing multipliers
export const SIZE_OPTIONS = [
  { id: '3.5g', label: '3.5g', multiplier: 1 },
  { id: '7g', label: '7g', multiplier: 1.85 },
  { id: '14g', label: '14g', multiplier: 3.5 }
];

export const PRODUCTS = [
  {
    id: "secret-13-n1",
    name: "Secret Nº1",
    secretName: "The Night Secret",
    subtitle: "The Night Secret",
    category: "night",
    tagline: "Not everything is meant to be shared.",
    description: "Designed for late hours, when the world slows down and silence takes over.",
    longDescription: "Not everything is meant to be shared.\n\nDesigned for late hours, when the world slows down and silence takes over.\n\nThis is a secret kept between you and the night.",
    experience: {
      feeling: "Deep calm, body relaxation, peaceful drift",
      bestFor: "Night • Wind down • Sleep preparation",
      atmosphere: "Quiet spaces • Alone • Low light"
    },
    effectProfile: "Heavy • Slow • Deep",
    basePrice: 185,
    price: 185,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/b0aec2e64468532c5d8b89b414f96a83cc86088bc55ba4c313650f384716c2a0.png",
    featured: true,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n1-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade"]
  },
  {
    id: "secret-13-n2",
    name: "Secret Nº2",
    secretName: "The Focus Secret",
    subtitle: "The Focus Secret",
    category: "focus",
    tagline: "Clarity is a choice.",
    description: "For moments that demand presence. When every thought needs to land exactly where it should.",
    longDescription: "Clarity is a choice.\n\nFor moments that demand presence. When every thought needs to land exactly where it should.\n\nThis secret sharpens what matters.",
    experience: {
      feeling: "Mental clarity, heightened focus, creative flow",
      bestFor: "Creative work • Deep thinking • Projects",
      atmosphere: "Studio • Desk • Morning light"
    },
    effectProfile: "Light • Clear • Focused",
    basePrice: 195,
    price: 195,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/fdbd40d3653003e3f87bdcb80f8f4e00bd4ab921f9ff3dc9e4caf8ded4781f88.png",
    featured: true,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n2-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade"]
  },
  {
    id: "secret-13-n3",
    name: "Secret Nº3",
    secretName: "The Calm Secret",
    subtitle: "The Calm Secret",
    category: "calm",
    tagline: "Some tensions were never meant to stay.",
    description: "A gentle unwinding. For when the weight of the day needs somewhere to go.",
    longDescription: "Some tensions were never meant to stay.\n\nA gentle unwinding. For when the weight of the day needs somewhere to go.\n\nThis secret knows how to let go.",
    experience: {
      feeling: "Gentle relaxation, stress release, soft ease",
      bestFor: "After work • Decompression • Transition",
      atmosphere: "Home • Couch • Soft music"
    },
    effectProfile: "Medium • Warm • Soft",
    basePrice: 175,
    price: 175,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/d2e985e77a9b98d1480447e913638af468eadc2164a31531f65963c250a8f02e.png",
    featured: true,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n3-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade"]
  },
  {
    id: "secret-13-n4",
    name: "Secret Nº4",
    secretName: "The Signature Secret",
    subtitle: "The Signature Secret",
    category: "signature",
    tagline: "Some experiences cannot be explained.",
    description: "Our most distinctive creation. Layered, complex, unforgettable.",
    longDescription: "Some experiences cannot be explained.\n\nOur most distinctive creation. Layered, complex, unforgettable.\n\nThis is the secret that defines the collection.",
    experience: {
      feeling: "Multidimensional, evolving, profound",
      bestFor: "Special occasions • Exploration • Connoisseurs",
      atmosphere: "Any • Adaptable • Personal ritual"
    },
    effectProfile: "Complex • Layered • Evolving",
    basePrice: 245,
    price: 245,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/b0aec2e64468532c5d8b89b414f96a83cc86088bc55ba4c313650f384716c2a0.png",
    featured: false,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n4-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade", "Limited Edition"]
  },
  {
    id: "secret-13-n5",
    name: "Secret Nº5",
    secretName: "The Deep Night Secret",
    subtitle: "The Deep Night Secret",
    category: "night",
    tagline: "For those who understand the value of silence.",
    description: "An elevated interpretation. Reserved for those seeking the ultimate nocturnal experience.",
    longDescription: "For those who understand the value of silence.\n\nAn elevated interpretation of The Night Secret. Reserved for those seeking the ultimate nocturnal experience.\n\nThis secret goes deeper.",
    experience: {
      feeling: "Profound relaxation, heavy calm, dream-like",
      bestFor: "Late night • Complete unwinding • Rest",
      atmosphere: "Darkness • Solitude • Stillness"
    },
    effectProfile: "Heavy • Sedating • Profound",
    basePrice: 285,
    price: 285,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/fdbd40d3653003e3f87bdcb80f8f4e00bd4ab921f9ff3dc9e4caf8ded4781f88.png",
    featured: false,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n5-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade", "Reserve"]
  },
  {
    id: "secret-13-n6",
    name: "Secret Nº6",
    secretName: "The Sharp Secret",
    subtitle: "The Sharp Secret",
    category: "focus",
    tagline: "Precision is an art.",
    description: "The pinnacle of mental clarity. For when good enough isn't enough.",
    longDescription: "Precision is an art.\n\nThe pinnacle of mental clarity. For when good enough isn't enough.\n\nThis secret cuts through the noise.",
    experience: {
      feeling: "Laser focus, sustained energy, peak performance",
      bestFor: "High-stakes work • Deadlines • Presentations",
      atmosphere: "Workspace • Bright light • Intention"
    },
    effectProfile: "Light • Sharp • Energizing",
    basePrice: 265,
    price: 265,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/d2e985e77a9b98d1480447e913638af468eadc2164a31531f65963c250a8f02e.png",
    featured: false,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n6-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade", "Elite"]
  },
  {
    id: "secret-13-n7",
    name: "Secret Nº7",
    secretName: "The Deep Calm Secret",
    subtitle: "The Deep Calm Secret",
    category: "calm",
    tagline: "Peace isn't found. It's created.",
    description: "When ordinary calm isn't enough. For profound, unshakeable tranquility.",
    longDescription: "Peace isn't found. It's created.\n\nWhen ordinary calm isn't enough. For profound, unshakeable tranquility.\n\nThis secret knows true stillness.",
    experience: {
      feeling: "Complete serenity, weightless, meditative",
      bestFor: "Stress relief • Meditation • Reset",
      atmosphere: "Sanctuary • Nature • Silence"
    },
    effectProfile: "Medium • Grounding • Serene",
    basePrice: 225,
    price: 225,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/b0aec2e64468532c5d8b89b414f96a83cc86088bc55ba4c313650f384716c2a0.png",
    featured: false,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n7-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade"]
  },
  {
    id: "secret-13-n8",
    name: "Secret Nº8",
    secretName: "The Rare Secret",
    subtitle: "The Rare Secret",
    category: "signature",
    tagline: "Not all secrets are meant for everyone.",
    description: "Our rarest creation. Produced in extremely limited quantities for true aficionados.",
    longDescription: "Not all secrets are meant for everyone.\n\nOur rarest creation. Produced in extremely limited quantities for true aficionados.\n\nThis secret is almost impossible to find.",
    experience: {
      feeling: "Transcendent, unique, ceremonial",
      bestFor: "Collectors • Celebration • Milestones",
      atmosphere: "Reverent • Intentional • Sacred"
    },
    effectProfile: "Complex • Rare • Transcendent",
    basePrice: 345,
    price: 345,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/fdbd40d3653003e3f87bdcb80f8f4e00bd4ab921f9ff3dc9e4caf8ded4781f88.png",
    featured: false,
    inStock: false,
    labTested: true,
    reportUrl: "/reports/secret-n8-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade", "Ultra Limited"]
  },
  {
    id: "secret-13-n9",
    name: "Secret Nº9",
    secretName: "The Essence Secret",
    subtitle: "The Essence Secret",
    category: "night",
    tagline: "Pure. Concentrated. Essential.",
    description: "The distilled essence of night. Concentrated for those who know what they're looking for.",
    longDescription: "Pure. Concentrated. Essential.\n\nThe distilled essence of night. Concentrated for those who know what they're looking for.\n\nThis secret is the purest form.",
    experience: {
      feeling: "Intense, immediate, essential",
      bestFor: "Experienced members • Efficiency • Ritual",
      atmosphere: "Personal • Minimal • Direct"
    },
    effectProfile: "Heavy • Concentrated • Immediate",
    basePrice: 215,
    price: 215,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/d2e985e77a9b98d1480447e913638af468eadc2164a31531f65963c250a8f02e.png",
    featured: false,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n9-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade", "Essence"]
  },
  {
    id: "secret-13-n10",
    name: "Secret Nº10",
    secretName: "The Discovery Secret",
    subtitle: "The Discovery Secret",
    category: "signature",
    tagline: "Every collection has a beginning.",
    description: "A curated introduction. Three secrets, one journey into the collection.",
    longDescription: "Every collection has a beginning.\n\nA curated introduction. Three secrets, one journey into the collection.\n\nThis is where the story starts.",
    experience: {
      feeling: "Exploratory, varied, introductory",
      bestFor: "New members • Gifts • Exploration",
      atmosphere: "Curious • Open • Discovery"
    },
    effectProfile: "Varied • Balanced • Approachable",
    basePrice: 125,
    price: 125,
    image: "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/b0aec2e64468532c5d8b89b414f96a83cc86088bc55ba4c313650f384716c2a0.png",
    featured: false,
    inStock: true,
    labTested: true,
    reportUrl: "/reports/secret-n10-lab-report.pdf",
    badges: ["Lab Tested", "Premium Grade", "Discovery"]
  }
];

export const COLLECTION_NOTES = [
  {
    id: "calm",
    name: "Calm Secrets",
    description: "Secrets designed for serenity and peace",
    image: "https://images.pexels.com/photos/3704955/pexels-photo-3704955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "focus",
    name: "Focus Secrets",
    description: "Secrets for clarity and precision",
    image: "https://images.unsplash.com/photo-1758568938040-fb8b7275ca5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwZmx1aWR8ZW58MHx8fHwxNzc0Nzk3MDQ3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "night",
    name: "Night Secrets",
    description: "Secrets for the late hours",
    image: "https://images.unsplash.com/photo-1758883019110-04c79dc56a71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwZmx1aWR8ZW58MHx8fHwxNzc0Nzk3MDQ3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "signature",
    name: "Signature Secrets",
    description: "Our most distinctive creations",
    image: "https://images.pexels.com/photos/3960244/pexels-photo-3960244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/aacff33a-a53f-439c-991a-2e6f6785f0a3/images/1bbe0130f71fe0511a6b35f70272eba608c53f52b3c698c05085f95198b3c9d0.png";

export const getProductById = (id) => PRODUCTS.find(p => p.id === id);

export const getFeaturedProducts = () => PRODUCTS.filter(p => p.featured);

export const getProductsByCategory = (category) => PRODUCTS.filter(p => p.category === category);
